import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaBuilding,
  FaWhatsapp,
} from "react-icons/fa";
import "./Footer.css";
import logo from "../logo.jpeg";

const location =
  "https://www.google.com/maps/place/14%C2%B009'57.3%22N+77%C2%B048'41.2%22E/@14.1659222,77.808857,17z";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Logo */}
      <div className="footer-logo">
        <img src={logo} alt="Sai Bhavana Realty Logo" />
        <h3>Sai Bhavana Realty</h3>
      </div>

      {/* Bottom 3 Columns */}
      <div className="footer-columns">
        {/* Quick Links */}
        <div className="footer-column footer-nav">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column footer-contact">
          <h4>Contact</h4>
          <p><FaBuilding className="icon" /> 3/3564, E.Govindappa Building, Main Road, Puttaparthi, Sri Sathya Sai District, Andhra Pradesh</p>
          <p><FaPhoneAlt className="icon" /> +91 9849109978, 8247452209</p>
          <p><FaEnvelope className="icon" /> sesaisurya999@gmail.com</p>
        </div>

        {/* Social Media */}
        <div className="footer-column footer-socials">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://wa.me/919849109978" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
            <a href="https://www.facebook.com/share/1FuAp8FaRY/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href={location} target="_blank" rel="noopener noreferrer"><FaMapMarkerAlt /></a>
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Sai Bhavana Realty. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;